import React, { Fragment, useMemo } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { ShoppingBag, Box, Codepen, Layers, Package } from 'react-feather';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import Departamentos from './departamentos';
import Subdepartamentos from './subdepartamentos';
import Marcas from './marcas';
import Niveles from './niveles';
import Unidades from './unidades';
import { useUserPermisos } from '../hooks/useUserPermisos';

const tabConfig = [
    {
        key: 'departamentos',
        label: 'Departamentos',
        icon: Box,
        component: Departamentos
    },
    {
        key: 'subdepartamentos',
        label: 'Subdepartamentos',
        icon: Codepen,
        component: Subdepartamentos
    },
    {
        key: 'marcas',
        label: 'Marcas',
        icon: ShoppingBag,
        component: Marcas
    },
    {
        key: 'niveles',
        label: 'Niveles',
        icon: Layers,
        component: Niveles
    },
    {
        key: 'unidades',
        label: 'Unidades',
        icon: Package,
        component: Unidades
    }
];

const Grupo = () => {
    const { permisos, loading } = useUserPermisos();

    const tabsVisibles = useMemo(() => {
    
        return tabConfig.filter(tab => permisos?.[tab.key]);
    }, [loading, permisos]);



    
    return (
        <Fragment>
            <Breadcrumb title="Grupo" parent="Inicio" />
            <div className="container-fluid">
                <div className="row theme-tab">
                    <Tabs className="col-sm-12">
                        <TabList className="tabs tab-title">
                            {tabsVisibles.map(({ key, label, icon: Icon }, index) => (
                                <Tab key={key} className={index === 0 ? 'current' : ''}>
                                    <Icon />{label}
                                </Tab>
                            ))}
                        </TabList>
                        <div className="tab-content-cls">
                            {tabsVisibles.map(({ key, component: Component }, index) => (
                                <TabPanel key={key}>
                                    <Component />
                                </TabPanel>
                            ))}
                        </div>
                    </Tabs>
                </div>
            </div>
        </Fragment>
    );
};

export default Grupo;
